import { Box, Container } from '@hover/blueprint';
import { motion } from '@hover/blueprint/foundation';
import { transitions } from 'polished';
import React, { FC, useEffect, useState } from 'react';
import { INavbarItem } from '../../../interfaces/INavbarItems';
import NavbarDesktop from './NavbarDesktop';
import NavbarMobile from './NavbarMobile';

interface Props {
  linksDesktop: INavbarItem[];
  linksMobile: INavbarItem[];
  navbarBackgroundColor: string | undefined;
  isNavbarWhite: boolean;
  showDivider: boolean;
  dividerColor: string | undefined;
  buttonType: string;
}

const Navbar: FC<Props> = ({
  linksDesktop,
  linksMobile,
  isNavbarWhite,
  navbarBackgroundColor,
  dividerColor,
  buttonType,
  showDivider,
}) => {
  const [navbarScrolled, setNavbarScrolled] = useState(false);
  const [showShadow, setShowShadow] = useState(false);

  useEffect(() => {
    const scrollHandler = () => setNavbarScrolled(window.scrollY >= 110);
    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  const navbarColor = navbarScrolled ? 'neutral.0' : navbarBackgroundColor;

  return (
    <Box
      maxW="100vw"
      w="100vw"
      bg={{ base: 'neutral.0', tablet: navbarColor }}
      justifyContent="center"
      position="fixed"
      top={0}
      zIndex="dropdown"
      {...transitions(
        ['background', 'box-shadow', 'border'],
        motion.easings[250],
      )}
      shadow={navbarScrolled || showShadow ? 'distance300' : 'invisibleNeutral'}
    >
      <Container maxW="1360px" overflow="hidden" px={{ base: 0, desktop: 400 }}>
        <Box display={{ desktop: 'flex', base: 'none' }} width="100%">
          <NavbarDesktop
            dividerColor={dividerColor}
            showDivider={showDivider}
            links={linksDesktop}
            navbarScrolled={navbarScrolled}
            isNavbarWhite={isNavbarWhite || navbarScrolled}
            showShadow={showShadow}
            setShowShadow={setShowShadow}
            buttonType={buttonType}
          />
        </Box>
        <Box display={{ desktop: 'none', base: 'flex' }} width="100%">
          <NavbarMobile
            dividerColor={dividerColor}
            showDivider={showDivider}
            navbarColor={navbarColor}
            navbarScrolled={navbarScrolled}
            links={linksMobile}
            isNavbarWhite={isNavbarWhite || navbarScrolled}
            buttonType={buttonType}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Navbar;
